export default "__VITE_ASSET__d6690b9c__"